import { useAssign } from '@/hooks/useErrorHandlingSagas'
import type { ReactNode } from 'react'
import { AssigneeSelect } from './AssigneeSelect'

type SagaAssigneeSelectProps = {
  ids: string[]                 // single id (row/detail) or many (bulk action bar)
  assigneeId?: string           // current assignee — only meaningful for a single saga
  assigneeName?: string
  onAssigned: () => void | Promise<void>
  isDisabled?: boolean
  restPlaceholder?: ReactNode
}

// Binds the pure AssigneeSelect to the saga Assign mutation over a set of ids (one row, the detail, or a bulk selection).
export const SagaAssigneeSelect = ({ ids, assigneeId, assigneeName, onAssigned, isDisabled, restPlaceholder }: SagaAssigneeSelectProps) => {
  const assign = useAssign()

  return (
    <AssigneeSelect
      assigneeId={assigneeId}
      assigneeName={assigneeName}
      isLoading={assign.isPending}
      isDisabled={isDisabled}
      restPlaceholder={restPlaceholder}
      onChange={async newAssigneeId => {
        await assign.mutateAsync({ ids, assigneeId: newAssigneeId })
        await onAssigned()
      }}
    />
  )
}
